import React, { useEffect, useRef, useState } from "react";
import { Tab } from "react-bootstrap";
import { connect, useDispatch } from "react-redux";
import { withRouter } from "../../../App";
import {
  getLoggedInUser,
  getLoggenInToken,
} from "../../../store/selectors/AuthSelectors";
import Modal from "react-bootstrap/Modal";
import { Button, Table, Pagination } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import * as XLSX from "xlsx";
import { post } from "../../../services/api";
import { toast } from "react-toastify";
import { calculateTotalCharge } from "../../../utils/calculateTotalCharge";
import moment from "moment";

const Reports = ({ token, loggedInUser }) => {
  const addLovModal = useRef();
  const dispatch = useDispatch();

  const [showModal, setShowModal] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [reportData, setReportData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPageCharge, setCurrentPageCharge] = useState(1);
  const [totalPagesCharge, setTotalPagesCharge] = useState(1);
  const [loading, setLoading] = useState(false);
  const [showCandidateReportModal, setShowCandidateReportModal] =
    useState(false); // New modal state
  const [candidateWeeklyReportData, setCandidateWeeklyReportData] = useState(
    []
  ); // New state for candidate weekly report
  const [recordsPerPageCharge, setRecordsPerPageCharge] = useState(10);
  const indexOfLastRecordCharge = currentPageCharge * recordsPerPageCharge;
  const indexOfFirstRecordCharge =
    indexOfLastRecordCharge - recordsPerPageCharge;
  const currentRecords = reportData.slice(
    indexOfFirstRecordCharge,
    indexOfLastRecordCharge
  );
  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPagesCharge) {
      setCurrentPageCharge(page);
    }
  };
  const [candidateRecordsPerPage, setCandidateRecordsPerPage] = useState(10);
  const [candidateCurrentPage, setCandidateCurrentPage] = useState(1);
  const indexOfLastRecord = candidateCurrentPage * candidateRecordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - candidateRecordsPerPage;
  const currentCandidateRecords = candidateWeeklyReportData.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );

  const totalCandidatePages = Math.ceil(
    candidateWeeklyReportData.length / candidateRecordsPerPage
  );
  const recordsPerPage = 10;
  const handleCandidatePageChange = (page) => {
    if (page > 0 && page <= totalCandidatePages) {
      setCandidateCurrentPage(page);
    }
  };
  useEffect(() => {
    const today = new Date();
    const dayOfWeek = today.getDay();
    const firstDayOfWeek = new Date(today);
    firstDayOfWeek.setDate(today.getDate() - (dayOfWeek === 0 ? 6 : dayOfWeek - 1));

    const lastDayOfWeek = new Date(firstDayOfWeek);
    lastDayOfWeek.setDate(firstDayOfWeek.getDate() + 6);

    setStartDate(firstDayOfWeek);
    setEndDate(lastDayOfWeek);
  }, []);

  const fetchCandidateWeeklyReportData = async () => {
    try {
      setLoading(true);
      const response = await post(
        "/api/timesheet/candidate-weekly-report",
        { startDate, endDate },
        token
      );
      setCandidateWeeklyReportData(response.data.data);
      setTotalPagesCharge(
        Math.ceil(response.data.data.length / recordsPerPage)
      ); // Calculate total pages
      setCurrentPageCharge(1); // Reset to page 1
    } catch (error) {
      toast.error("Error fetching while candidate weekly report data.");
      console.error("Error fetching candidate weekly report data:", error);
    } finally {
      setLoading(false);
    }
  };
  const openCandidateReportModal = () => {
    setShowCandidateReportModal(true);
    setLoading(true);
    fetchCandidateWeeklyReportData();
  };
  const fetchReportData = async () => {
    setLoading(true);
    try {
      const response = await post(
        "/api/timesheet/weekly-invoice-report",
        { startDate, endDate },
        token
      );
      setReportData(response.data.data); // Store all data here
      setTotalPagesCharge(
        Math.ceil(response.data.data.length / recordsPerPage)
      ); // Calculate total pages
      setCurrentPage(1); // Reset to page 1
    } catch (error) {
      console.error("Error fetching report data:", error);
    } finally {
      setLoading(false);
    }
  };

  const downloadExcel = async () => {
    // Show loading indicator
    setLoading(true);
    
    try {
      // Fetch all data for export (not just current page)
      const response = await post(
        "/api/timesheet/weekly-invoice-report",
        { startDate, endDate },
        token
      );
      
      const allData = response.data.data;
      
      // Check if we have data to export
      if (!allData || allData.length === 0) {
        toast.warning("No data available to export.");
        setLoading(false);
        return;
      }
      
      // Prepare all data for export
      const exportData = allData.map(item => ({
          "Company Name": item.companyName,
          "Invoice Date": item.invoiceDate,
          "Invoice Number": item.invoiceNumber,
          "Net Charge (£)": calculateTotalCharge(item.invoicesItems), 
          "VAT (£)": Number(item.invoiceVat), 
          "Total Charge (£)": Number(item.totalInvoice) 
      }));
      
      // Generate Excel file with all data
      const worksheet = XLSX.utils.json_to_sheet(exportData);    
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Weekly Invoice Charges");
      XLSX.writeFile(workbook, "Weekly_Invoice_Charges_Report.xlsx");
      
      toast.success(`Successfully exported ${exportData.length} records`);
    } catch (error) {
      console.error("Error exporting data:", error);
      toast.error("Failed to export data. Please try again.");
    } finally {
      setLoading(false);
    }
};


const downloadCandidateWeeklyReportExcel = async () => {
  // Show loading indicator
  setLoading(true);
  
  try {
    // Fetch all data for export (not just current page)
    const response = await post(
      "/api/timesheet/candidate-weekly-report",
      { startDate, endDate },
      token
    );
    
    const allData = response.data.data;
    
    // Check if we have data to export
    if (!allData || allData.length === 0) {
      toast.warning("No data available to export.");
      setLoading(false);
      return;
    }
    
    const exportData = allData.map((item) => ({
      "Payroll No": item.payrollNo,
      "Company": item.companyName,
      "First Name": item.firstName,
      "Last Name": item.lastName,
      "Hours Worked": Number(item.weeklyHours || 0),
      "Pay Rate (£)": String(item.payRate || "0"),
      "Normal Pay (£)": Number(item.normalPay || 0),
      "Overtime Hours": Number(item.overTimeHours || 0),
      "Overtime Rate (£)": String(item.overTimePayRate || "0"),
      "Overtime Pay (£)": Number(item.overTimePay || 0),
      "Bank Holiday OT Hours": Number(item.bankHolidayOverTimeHours || 0),
      "Bank Holiday OT Rate (£)": String(item.bankHolidayOverTimePayRate || "0"),
      "Bank Holiday OT Pay (£)": Number(item.bankHolidayPay || 0),
      "Night Rate Hours": Number(item.nightRateHours || 0),
      "Night Rate (£)": String(item.nightRatePayRate || "0"),
      "Night Rate Pay (£)": Number(item.nightRatePay || 0),
      "Total Pay (£)": Number(item.totalPay || 0),
    }));
    
    // Generate Excel file with all data
    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Candidate Payroll Report");
    XLSX.writeFile(workbook, "Candidate_Payroll_Report.xlsx");
    
    toast.success(`Successfully exported ${exportData.length} records`);
  } catch (error) {
    console.error("Error exporting data:", error);
    toast.error("Failed to export data. Please try again.");
  } finally {
    setLoading(false);
  }
};

  const [showAllInvoicesModal, setShowAllInvoicesModal] = useState(false);
  const [allInvoices, setAllInvoices] = useState([]);
  const [allInvoicesPagination, setAllInvoicesPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalInvoices: 0
  });
  const [allInvoicesLoading, setAllInvoicesLoading] = useState(false);
  const [allInvoicesFilter, setAllInvoicesFilter] = useState({
    startDate: null,
    endDate: null,
    companyName: '',
    status: ''
  });

  // Add a new state to store license information
  const [licensePagination, setLicensePagination] = useState({
    licenseNo: '',
    totalInvoices: 0
  });

  // Modify the fetchAllInvoices function to update license pagination
  const fetchAllInvoices = async (page = 1) => {
    setAllInvoicesLoading(true);
    try {
      const response = await post(
        "/api/timesheet/all-invoices", 
        {
          page,
          limit: 20,
          startDate: allInvoicesFilter.startDate,
          endDate: allInvoicesFilter.endDate,
          companyName: allInvoicesFilter.companyName,
          status: allInvoicesFilter.status
        }, 
        token
      );

      setAllInvoices(response.data.data);
      setAllInvoicesPagination({
        currentPage: response.data.pagination.currentPage,
        totalPages: response.data.pagination.totalPages,
        totalInvoices: response.data.pagination.totalInvoices
      });

      // Update license pagination information
      setLicensePagination({
        licenseNo: response.data.pagination.licenseNo,
        totalInvoices: response.data.pagination.totalInvoices
      });
    } catch (error) {
      console.error("Error fetching all invoices:", error);
      toast.error("Failed to fetch invoices. Please try again.");
    } finally {
      setAllInvoicesLoading(false);
    }
  };

  const handleAllInvoicesPageChange = (page) => {
    fetchAllInvoices(page);
  };

  const handleAllInvoicesFilterChange = (e) => {
    const { name, value } = e.target;
    setAllInvoicesFilter(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const applyAllInvoicesFilters = () => {
    fetchAllInvoices(1);
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <Tab.Container defaultActiveKey={"Reports"}>
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h4 className="heading mb-0">Reports</h4>
            </div>
            <div className="col-xl-12 active-p" style={{ height: "100vh" }}>
              <div className="card">
                <div className="card-body p-4">
                  <button
                    className="btn btn-primary"
                    onClick={() => {
                      setShowModal(true);
                      fetchReportData();
                    }}
                  >
                    Weekly Invoice Charge Total Reports - Export to excel
                  </button>
                  <br />
                  <button
                    className="btn btn-primary mt-4"
                    onClick={openCandidateReportModal}
                  >
                    Requirement Payroll Listing - Export to excel
                  </button>
                  <br />
                  <button
                    className="btn btn-primary mt-4"
                    onClick={() => {
                      setShowAllInvoicesModal(true);
                      fetchAllInvoices();
                    }}
                  >
                    Show All Invoices
                  </button>
                </div>
              </div>
            </div>
          </Tab.Container>
        </div>
      </div>

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
        className="modal fade"
      >
        <Modal.Header closeButton>
          <Modal.Title>Weekly Invoice Charge Total Report</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-between mb-3">
            <div>
              <label>Start Date</label>
              <DatePicker
                selected={startDate}
                dateFormat="dd-MM-yyyy"
                onChange={(date) => setStartDate(date)}
                className="form-control"
                showWeekNumbers={false}
                locale="en-GB"
                calendarStartDay={1}
                weekStart={1}
              />
            </div>
            <div>
              <label>End Date</label>
              <DatePicker
                selected={endDate}
                dateFormat="dd-MM-yyyy"
                onChange={(date) => setEndDate(date)}
                className="form-control"
                showWeekNumbers={false}
                locale="en-GB"
                calendarStartDay={1}
                weekStart={1}
              />
            </div>
            <div>
              <Button
                variant="primary"
                size="sm"
                className="mt-4"
                onClick={fetchReportData}
              >
                Generate Report
              </Button>
            </div>
          </div>

          {loading ? (
            <p>Loading...</p>
          ) : (
            <div>
              <div className="table-responsive">
                <Table bordered striped>
                  <thead>
                    <tr>
                      <th>Company Name</th>
                      <th>Invoice Date</th>
                      <th>Invoice Number</th>
                      <th>Net Charge</th>
                      <th>VAT</th>
                      <th>Total Charge</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentRecords.map((item, index) => (
                      <tr key={index}>
                        <td>{item.companyName}</td>
                        <td>{item.invoiceDate}</td>
                        <td>{item.invoiceNumber}</td>
                        <td>
                          &#xa3;{calculateTotalCharge(item.invoicesItems)}
                        </td>
                        <td>&#xa3;{Number(item.invoiceVat).toFixed(2)}</td>
                        <td>&#xa3;{Number(item.totalInvoice).toFixed(2)}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>

              <div className="d-flex justify-content-between">
                <Button onClick={downloadExcel}>Download Excel</Button>
                <Pagination>
                  <Pagination.Prev
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  />
                  {Array.from({ length: totalPagesCharge }, (_, i) => (
                    <Pagination.Item
                      key={i + 1}
                      active={i + 1 === currentPageCharge}
                      onClick={() => handlePageChange(i + 1)}
                    >
                      {i + 1}
                    </Pagination.Item>
                  ))}
                  <Pagination.Next
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPagesCharge}
                  />
                </Pagination>
              </div>
            </div>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Modal for Candidate Weekly Report */}
      <Modal
        show={showCandidateReportModal}
        onHide={() => setShowCandidateReportModal(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
        className="modal fade"
      >
        <Modal.Header closeButton>
          <Modal.Title>Requirement Payroll Listing</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-between mb-3">
            <div>
              <label>Start Date</label>
              <DatePicker
                selected={startDate}
                dateFormat="dd-MM-yyyy"
                onChange={(date) => setStartDate(date)}
                className="form-control"
                showWeekNumbers={false}
                locale="en-GB"
                calendarStartDay={1}
                weekStart={1}
              />
            </div>
            <div>
              <label>End Date</label>
              <DatePicker
                selected={endDate}
                dateFormat="dd-MM-yyyy"
                onChange={(date) => setEndDate(date)}
                className="form-control"
                showWeekNumbers={false}
                locale="en-GB"
                calendarStartDay={1}
                weekStart={1}
              />
            </div>
            <div>
              <Button
                variant="primary"
                className="mt-4"
                size="sm"
                onClick={fetchCandidateWeeklyReportData}
              >
                Generate Report
              </Button>
            </div>
          </div>

          {loading ? (
            <p>Loading...</p>
          ) : (
            <div className="table-responsive">
              <Table bordered striped>
                <thead>
                  <tr>
                    <th>Payroll No</th>
                    <th>Company</th>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Normal<br/>Hours</th>
                    <th>Pay</th>
                    <th>Overtime Hours</th>
                    <th>Overtime Pay</th>
                    <th>Bank Holiday<br/>Overtime Hours</th>
                    <th>Bank Holiday<br/>Overtime Pay</th>
                    <th>Night Rate<br/>Hours</th>
                    <th>Night Rate<br/>Pay</th>
                    <th>Total Pay</th>
                  </tr>
                </thead>
                <tbody>
                  {currentCandidateRecords.length > 0 && currentCandidateRecords.map((item, index) => (
                    <tr key={index}>
                      <td>{item.payrollNo || "--"}</td>
                      <td>{item.companyName || "--"}</td>
                      <td>{item.firstName || "--"}</td>
                      <td>{item.lastName || "--"}</td>
                      <td>{item.weeklyHours || "--"}</td>
                      <td>{item.normalPay || "--"}</td>
                      <td>{item.overTimeHours || "--"}</td>
                      <td>{item.overTimePay || "--"}</td>
                      <td>{item.bankHolidayOverTimeHours || "--"}</td>
                      <td>{item.bankHolidayPay || "--"}</td>
                      <td>{item.nightRateHours || "--"}</td>
                      <td>{item.nightRatePay || "--"}</td>
                      <td>{item.totalPay || "--"}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>

              {currentCandidateRecords.length > 0 && (
                <div className="d-flex justify-content-between">
                  <Pagination>
                    <Pagination.Prev
                      onClick={() =>
                        handleCandidatePageChange(candidateCurrentPage - 1)
                      }
                    />
                    {Array.from({ length: totalCandidatePages }, (_, i) => (
                      <Pagination.Item
                        key={i + 1}
                        active={i + 1 === candidateCurrentPage}
                        onClick={() => handleCandidatePageChange(i + 1)}
                      >
                        {i + 1}
                      </Pagination.Item>
                    ))}
                    <Pagination.Next
                      onClick={() =>
                        handleCandidatePageChange(candidateCurrentPage + 1)
                      }
                    />
                  </Pagination>
                </div>
              )}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          {!loading && (
            <Button
              variant="primary"
              onClick={downloadCandidateWeeklyReportExcel}
            >
              Export to Excel
            </Button>
          )}
          <Button
            variant="secondary"
            onClick={() => setShowCandidateReportModal(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showAllInvoicesModal}
        onHide={() => setShowAllInvoicesModal(false)}
        backdrop="static"
        keyboard={false}
        size="xl"
        className="modal fade"
      >
        <Modal.Header closeButton>
          <Modal.Title>All Invoices</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row mb-3">
            <div className="col-md-3">
              <label>Start Date</label>
              <DatePicker
                selected={allInvoicesFilter.startDate}
                dateFormat="dd-MM-yyyy"
                onChange={(date) => setAllInvoicesFilter(prev => ({ ...prev, startDate: date }))}
                className="form-control"
                showWeekNumbers={false}
                locale="en-GB"
                calendarStartDay={1}
                weekStart={1}
                isClearable
              />
            </div>
            <div className="col-md-3">
              <label>End Date</label>
              <DatePicker
                selected={allInvoicesFilter.endDate}
                dateFormat="dd-MM-yyyy"
                onChange={(date) => setAllInvoicesFilter(prev => ({ ...prev, endDate: date }))}
                className="form-control"
                showWeekNumbers={false}
                locale="en-GB"
                calendarStartDay={1}
                weekStart={1}
                isClearable
              />
            </div>
            <div className="col-md-3">
              <label>Company Name</label>
              <input
                type="text"
                name="companyName"
                value={allInvoicesFilter.companyName}
                onChange={handleAllInvoicesFilterChange}
                className="form-control"
                placeholder="Search by company"
              />
            </div>
            {/* <div className="col-md-3">
              <label>Status</label>
              <select
                name="status"
                value={allInvoicesFilter.status}
                onChange={handleAllInvoicesFilterChange}
                className="form-control"
              >
                <option value="">All Statuses</option>
                <option value="paid">Paid</option>
                <option value="pending">Pending</option>
                <option value="overdue">Overdue</option>
              </select>
            </div> */}
          </div>
          <div className="row mb-3">
            <div className="col-12 text-right">
              <Button 
                variant="primary" 
                onClick={applyAllInvoicesFilters}
                disabled={allInvoicesLoading}
              >
                Apply Filters
              </Button>
            </div>
          </div>

          {allInvoicesLoading ? (
            <p>Loading invoices...</p>
          ) : (
            <div className="table-responsive">
              <Table bordered striped>
                <thead>
                  <tr>
                    <th>Invoice No</th>
                    <th>Date</th>
                    <th>Company</th>
                    <th>Candidate</th>
                    <th>Job Title</th>
                    <th>Net Amount</th>
                    <th>VAT</th>
                    <th>Total Amount</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {allInvoices.map((invoice, index) => (
                    <tr key={index}>
                      <td>{invoice.invoiceNumber}</td>
                      <td>{moment(invoice.invoiceDate).format("DD/MM/YYYY")}</td>
                      <td>{invoice.company}</td>
                      <td>{`${invoice.candidateFirstName} ${invoice.candidateLastName}`.trim()}</td>
                      <td>{invoice.jobTitle}</td>
                      <td>£{Number(invoice.totalInvoice - invoice.invoiceVat).toFixed(2)}</td>
                      <td>£{Number(invoice.invoiceVat).toFixed(2)}</td>
                      <td>£{Number(invoice.totalInvoice).toFixed(2)}</td>
                      <td>
                        <span className={`badge ${
                          invoice.status.toLowerCase() === 'present' ? 'badge-success' : 
                          invoice.status.toLowerCase() === 'pending' ? 'badge-warning' : 
                          invoice.status.toLowerCase() === 'draft' ? 'badge-secondary' : 
                          invoice.status.toLowerCase() === 'paid' ? 'badge-success' : 
                          invoice.status.toLowerCase() === 'absent' ? 'badge-danger' : 
                          'badge-info'
                        }`}>
                          {invoice.status || 'No Status'}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>

              <div className="d-flex justify-content-between">
                <Pagination>
                  <Pagination.Prev
                    onClick={() => handleAllInvoicesPageChange(allInvoicesPagination.currentPage - 1)}
                    disabled={allInvoicesPagination.currentPage === 1}
                  />
                  {Array.from({ length: allInvoicesPagination.totalPages }, (_, i) => (
                    <Pagination.Item
                      key={i + 1}
                      active={i + 1 === allInvoicesPagination.currentPage}
                      onClick={() => handleAllInvoicesPageChange(i + 1)}
                    >
                      {i + 1}
                    </Pagination.Item>
                  ))}
                  <Pagination.Next
                    onClick={() => handleAllInvoicesPageChange(allInvoicesPagination.currentPage + 1)}
                    disabled={allInvoicesPagination.currentPage === allInvoicesPagination.totalPages}
                  />
                </Pagination>
                <div>
                  Total Invoices: {allInvoicesPagination.totalInvoices}
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <div className="mr-auto">
            <small>
              License: {licensePagination.licenseNo} | 
              Total Invoices: {licensePagination.totalInvoices}
            </small>
          </div>
          <Button variant="secondary" onClick={() => setShowAllInvoicesModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    token: getLoggenInToken(state),
    loggedInUser: getLoggedInUser(state),
  };
};

export default withRouter(connect(mapStateToProps)(Reports));
